import { z } from 'zod';

import { ZodCountryCode } from '@Common/types/zod/zod-country-code';
import { endpoint, GetEndpointType } from '@Common/types/zod/zod-endpoint';
import { createZodParamsValidator } from '@Common/types/zod/zod-params';
import { ZodTrimmedString } from '@Common/types/zod/zod-trimmed-string';

/**
 * GET questions/invest_ranges
 */

export const ZodGetInvestRangesParams = createZodParamsValidator(
  z.object({
    country_code: ZodCountryCode,
  }),
);

export type GetInvestRangesParams = z.infer<typeof ZodGetInvestRangesParams>;

export const ZodGetInvestRangesResponseOne = z.object({
  label: ZodTrimmedString,
  index: z.number().int(),
});

export type GetInvestRangesResponseOne = z.infer<typeof ZodGetInvestRangesResponseOne>;

export const ZodGetInvestRangesResponse = z.object({
  ranges: z.array(ZodGetInvestRangesResponseOne),
});

export type GetInvestRangesResponse = z.infer<typeof ZodGetInvestRangesResponse>;

export const getQuestionsInvestRangesEndpoint = endpoint({
  method: 'GET',
  pathParams: ZodGetInvestRangesParams,
  responseBody: ZodGetInvestRangesResponse,
});

export type GetQuestionsInvestRangesEndpoint = GetEndpointType<
  typeof getQuestionsInvestRangesEndpoint
>;
